const sideloaded = window['__session__'] || {};
const channelSettings = window['ChannelSettings'] || {};
export const GB = 1024 * 1024 * 1024;

window['ChannelSettings'] = undefined;

let account = {};
// Grab account from profile or logged in user
if (sideloaded.profile) {
  account = sideloaded.profile;
}

function sanitizeAccountDefaultRecipient(accountDefaultRecipient) {
  if (typeof accountDefaultRecipient === 'string') {
    const trimmed = accountDefaultRecipient.trim();

    return trimmed !== '' && trimmed;
  }

  return false;
}

export function channel(account, channelSettings) {
  return {
    name: account.subdomain_name ? account.subdomain_name : false,
    defaultRecipient: sanitizeAccountDefaultRecipient(
      account.default_recipient_email
    ),
    defaultRecipientVerified: account.receiving_email_confirmed,
    profileReceivingLocked: account.profile_receiving_locked,
    inboundTransferSizeLimit:
      channelSettings.inboundTransferSizeLimit > 2 * GB
        ? channelSettings.inboundTransferSizeLimit
        : false,
  };
}

export default channel(account, channelSettings);
